const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.752,
    height: 15.353,
    viewBox: "0 0 15.752 15.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M9.051,16.972l-.78.78a.84.84,0,0,1-1.192,0L.244,10.921a.84.84,0,0,1,0-1.192L7.079,2.9a.84.84,0,0,1,1.192,0l.78.78a.845.845,0,0,1-.014,1.206L4.8,8.917H14.9a.842.842,0,0,1,.844.844v1.125a.842.842,0,0,1-.844.844H4.8l4.236,4.036A.839.839,0,0,1,9.051,16.972Z",
    transform: "translate(0.004 -2.647)",
    fill: "#fff"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.cc14247996f407aa7564462de92f9d2c.svg";
export { ForwardRef as ReactComponent };